<template>
  <v-card class="pt-4 mx-auto" max-width="600">
    <v-card-title v-if="!showOnlyImport" class="px-4">{{ $t('mcimportexport.title') }}</v-card-title>
    <v-card-text v-if="!showOnlyImport">
      <v-row justify="center" align="center">
        <v-col cols="10" class="ma-0 pa-0">
          <v-text-field
            v-model="pid"
            :label="$t('app.att.pid')"
            readonly
            disabled
          ></v-text-field>
        </v-col>
        <v-col cols="1" class="ma-0 pa-0">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">mdi-information-outline</v-icon>
            </template>
            <span>{{ $t('settings.pid') }}</span>
          </v-tooltip>
        </v-col>
        <v-col cols="10" class="ma-0 pa-0">
          <v-text-field
            v-model="iid"
            :label="$t('app.att.iid')"
            readonly
            disabled
          ></v-text-field>
        </v-col>
        <v-col cols="1" class="ma-0 pa-0">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">mdi-information-outline</v-icon>
            </template>
            <span>{{ $t('settings.iid') }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="d-flex justify-center">
      <v-dialog  v-if="!showOnlyImport" v-model="exportDialogShow" persistent max-width="350" light>
        <template v-slot:activator="{ on }">
          <v-btn color="secondary" dark v-on="on" class="mx-2">
            {{ $t("app.btn.export")}}
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="d-flex justify-center ma-0">
            {{$t('mcimportexport.exportTitle')}}
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="password"
              :label="$t('mcimportexport.passwordExport')"
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show ? 'text' : 'password'"
              counter
              @click:append="show = !show"
            ></v-text-field>
            <v-btn color="primary" small @click="download()">{{$t('app.btn.download')}}</v-btn>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon class="mx-4" v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>{{ $t('mcimportexport.exportDesc') }}</span>
            </v-tooltip>
          </v-card-text>
          <v-card-actions class="d-flex justify-end">
            <v-btn color="primary" small @click="closeExportDialog()">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="importDialogShow" persistent max-width="350" light>
        <template v-slot:activator="{ on }">
          <v-btn color="secondary" dark v-on="on" class="mx-2">
            {{ $t(importButtonText)}}
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="d-flex justify-center ma-0">
            {{$t('mcimportexport.importTitle')}}
          </v-card-title>
          <v-card-text>
            <v-form v-model="valid">
              <v-file-input
                v-model="configFile"
                accept=".mee"
                :label="$t('mcimportexport.importFile')"
              >
              </v-file-input>
              <v-text-field
                v-model="password"
                :label="$t('mcimportexport.passwordImport')"
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show ? 'text' : 'password'"
                counter
                @click:append="show = !show"
                :rules="rules"
              ></v-text-field>
              <v-btn color="primary" small @click="upload()">{{$t('app.btn.upload')}}</v-btn>
              <v-btn v-if="loadedData" class="mx-2" color="primary" small @click="activate()">{{$t('app.btn.activate')}}</v-btn>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon class="mx-4" v-on="on">mdi-information-outline</v-icon>
                </template>
                <span>{{ $t('mcimportexport.importDesc') }}</span>
              </v-tooltip>
            </v-form>
          </v-card-text>
          <v-card-actions class="d-flex justify-end">
            <v-btn color="primary" small @click="closeImportDialog()">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'McImportExport',
  components: {
  },
  props: {
    showOnlyImport: Boolean,
    importButtonText: String
  },
  data: () => ({
    valid: true,
    exportDialogShow: false,
    importDialogShow: false,
    password: '',
    show: false,
    configFile: [],
    loadedData: null,
    formData: {
      pid: '',
      desc: '',
      type: 0,
    },
    rules: [
        value => (value || '').length <= 100 || 'Maximálně 100 znaků'
      ],
  }),
  computed: {
    ...mapState(['pid', 'iid'])
  },
  methods: {
    reset() {
      this.valid = false
      this.scanPanel = 0
      this.formData.pid = ''
      this.formData.desc = ''
    },
    download() {
      try {
        var aes = require('crypto-js/aes')
        var localData = JSON.stringify(this.$store.getters.getLocalData)
        var data = aes.encrypt(localData, this.password)
        var blob = new Blob([data], { type: 'application/octet-stream;' })
        var objdata = this.window.URL.createObjectURL(blob);
        //for IE
        if (this.window.navigator && this.window.navigator.msSaveOrOpenBlob) {
            this.window.navigator.msSaveOrOpenBlob(blob);
            return;
        }
        var link = this.document.createElement('a')
        link.href = objdata
        link.download="meeconn-configuration.mee"
        link.click()
      } catch (err) {
          this.$parent.$emit('error', this.$t('mcimportexport.errExport') + ' ' + err)
      }
    },
    upload() {
      try {
        var reader = new FileReader()
        var self = this
        reader.onload = function (e) {
          try {
            var cjs = require('crypto-js')
            var aes = require('crypto-js/aes')
            var data = aes.decrypt(e.target.result, self.password)
            var localData = JSON.parse(data.toString(cjs.enc.Utf8))
            self.loadedData = localData
          } catch (err) {
              self.$parent.$emit('error', self.$t('mcimportexport.errImport'))
          }
        }
        reader.readAsBinaryString(this.configFile)
        //reader.readAsDataURL(this.configFile)
      } catch (err) {
          this.$parent.$emit('error', this.$t('mcimportexport.errExport') + ' ' + err)
      }
    },
    async activate() {
        await this.$store.dispatch('restore', this.loadedData)
        this.$parent.$emit('info', this.$t('mcimportexport.infoLoaded'))
        this.loadedData = null
    },
    closeExportDialog() {
      this.exportDialogShow = false;
    },
    closeImportDialog() {
      this.importDialogShow = false;
    }
  }
}
</script>
